import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import camelCase from 'lodash/camelCase';

const validateScriptCode = (scriptCode) => {
    return /^\w+$/.test(scriptCode);
};

const mapKeysToCamelCaseDeep = (obj) => {
    if (Array.isArray(obj)) return obj.map(mapKeysToCamelCaseDeep);
    if (obj && typeof obj === 'object') {
        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [camelCase(key), mapKeysToCamelCaseDeep(value)])
        );
    }

    return obj;
};

const loadBanner = function (scriptCode) {
    let script = document.createElement('script');
    if (!validateScriptCode(scriptCode)) return script;
    script.id = 'js_' + scriptCode;
    script.type = 'text/javascript';
    script.src = `${
        window.globalConfig.COMMON_URL
    }/bannerad/js/zone/sdceo_zone_${scriptCode}_banner.js?date=${moment().format('YYYYMMDDHHmm')}`;
    document.head.appendChild(script);
    return script;
};

export const useBanners = ({ enable = false, product = 'GL', raceNo }) => {
    const [banners, setBanners] = useState([]);
    const { i18n } = useTranslation();

    useEffect(() => {
        if (!enable) return;

        const { getBannerListUrl, getBannerListApiKey, zoneCodes } = window.globalConfig.SITECORE_BANNER_AD_CONFIG;
        const searchParams = new URLSearchParams(window.location.search);
        const previewDate = searchParams.get('bannerDate');

        fetch(getBannerListUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                sc_apikey: getBannerListApiKey
            },
            body: JSON.stringify({
                language: i18n.language === 'ch' ? 'zh-hk' : 'en-us',
                zoneCode: zoneCodes[product],
                date: previewDate || undefined // using || here because URL search param can be "", and we want to treat it as not previewing banners
            })
        })
            .then((res) => res.json())
            .then((body) => setBanners(mapKeysToCamelCaseDeep(body.data.BannerADs ?? []))) // new API response has pascal case keys, converting them to camel case for compatibility
            .catch((error) => console.warn('Fail to load banners', error));
    }, [enable, i18n.language, product, raceNo]);

    return banners;
};
